<template>
	<div @click="login(username, password)">
		<slot></slot>
	</div>
</template>

<script>
import { login } from './Login';
export default {
	props: ['username', 'password'],
	mixins: [login],
	methods: {
		async login(user = '', pass = '') {
			let loginData = this.loginData;
			loginData.error = false;
			this.updateProperty({
				property: 'loginData',
				value: loginData
			});

			if(user.length && pass.length){
				let login_data = {
					user: user,
					pass: pass,
				};
				try {
					let response = await this.$api.post('qzr-data/login', login_data);
					await this.getNonce(response.data);
					this.$emit('onLoginSuccess');
				} catch(e) {
					this.invalidLogin('Credenziali non valide');
					this.$emit('onLoginError');
				}
			} else {
				this.invalidLogin('Compila entrambi i campi');
				this.$emit('onLoginError');
			}
		},
	},
};
</script>

<style lang="scss" scoped></style>
